import * as React from "react";
import type { SVGProps } from "react";
const SvgMastercardBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 35 25"
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.518}
      fill="#fff"
      stroke="#D9D9D9"
      rx={3.5}
    />
    <path
      fill="#ED0006"
      fillRule="evenodd"
      d="M17.75 17.175a6.75 6.75 0 0 1-4.426 1.648c-3.769 0-6.824-3.09-6.824-6.902s3.055-6.903 6.824-6.903a6.75 6.75 0 0 1 4.426 1.649 6.75 6.75 0 0 1 4.426-1.65c3.769 0 6.824 3.091 6.824 6.904s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65"
      clipRule="evenodd"
    />
    <path
      fill="#F9A000"
      fillRule="evenodd"
      d="M17.75 17.175a6.92 6.92 0 0 0 2.398-5.254 6.92 6.92 0 0 0-2.398-5.254 6.75 6.75 0 0 1 4.426-1.65c3.769 0 6.824 3.091 6.824 6.904s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65"
      clipRule="evenodd"
    />
    <path
      fill="#FF5E00"
      fillRule="evenodd"
      d="M17.75 6.667a6.92 6.92 0 0 1 2.398 5.253 6.92 6.92 0 0 1-2.398 5.254 6.92 6.92 0 0 1-2.398-5.254 6.92 6.92 0 0 1 2.398-5.253"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMastercardBlock;
